/* eslint-disable react/prop-types */
import React from 'react';
import { PropTypes } from 'prop-types';

import { Select, Input, Form } from 'antd';

const { Option } = Select;

const TransactionChargebackForm = ({
  form, handleStatusChange, selectedTransaction, selectedStatus, kitegatewayReference,
}) => {
  const transactionStatuses = [
    { status: 'COMPLETED', label: 'Lost' },
    { status: 'CANCELLED', label: 'Won' },
  ].map((tStatus) => (
    <Option key={tStatus.status} value={tStatus.status}>
      {tStatus.label}
    </Option>
  ));

  return (
    <Form
      name="basic"
      className="gx-form-row0"
      ref={form}
      initialValues={{
        transaction_status: selectedTransaction.transaction_status,
      }}
    >
      <div>New Status</div>
      <Form.Item>
        <Select
          allowClear
          showArrow
          style={{ width: '100%' }}
          placeholder="Please select status"
          onChange={(e) => handleStatusChange(e)}
          defaultValue={selectedStatus}
        >
          {transactionStatuses}
        </Select>
      </Form.Item>

      <Form.Item
        name="kitegateway_reference"
        initialValue={kitegatewayReference}
      >
        <Input readOnly />
      </Form.Item>
    </Form>
  );
};

TransactionChargebackForm.propTypes = {
  form: PropTypes.shape({
    current: PropTypes.shape({}),
  }),
  handleStatusChange: PropTypes.func.isRequired,
  selectedTransaction: PropTypes.oneOfType([
    PropTypes.object,
  ]).isRequired,
  selectedStatus: PropTypes.string.isRequired,
  kitegatewayReference: PropTypes.string,
};

TransactionChargebackForm.defaultProps = {
  form: {},
  kitegatewayReference: '',
};

export default TransactionChargebackForm;
